import { Component } from '@angular/core';

import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-footer',
    template: `
        <div class="surface-section px-4 md:px-6 lg:px-8 layout-footer">
            <div class="py-6 flex flex-column sm:flex-row sm:align-items-center justify-content-between">
                <div>
                    <a href="{{ appConfig.app.contact.url }}" class="layout-logo">
                        <img src="assets/layout/images/facturar-facil-ecuador-white.svg" alt="{{appConfig.app.name }}" style="width: 75%;" />
                    </a>
                    <div class="mt-2 line-height-3">&copy; 2024 Tecnopro & jlgranda. Todos los derechos reservados</div>
                </div>
                <div>
                    <ul class="list-unstyled li-space-lg p-small">
                        <li class="media">
                            <i class="fas fa-map-marker-alt"></i>
                            <div class="media-body">Shyris N35 y Suecia, Quito, Ecuador</div>
                        </li>
                        <li class="media">
                            <i class="fas fa-envelope"></i>
                            <div class="media-body"><a class="white" href="mailto:info@facturafacilecuador.com">info@facturafacilecuador.com</a></div>
                        </li>
                        <li class="media">
                            <i class="fas fa-phone-alt"></i>
                            <div class="media-body"><a class="white" href="https://api.whatsapp.com/send?phone=593958648988&text=Hola, Nececito mas informacion!">+0958648988</a></div>
                        </li>
                    </ul>
                </div>
                <div class="mt-3 sm:mt-0">
                    <a class="cursor-pointer text-500 ml-3 transition-colors transition-duration-150 hover:text-700"
                    href="http://facebook.com.com/facturafacilecuador">
                        <i class="pi pi-facebook text-xl"></i>
                    </a>
                    <a class="cursor-pointer text-500 ml-3 transition-colors transition-duration-150 hover:text-700"
                    href="http://instagram.com/facturafacilecuador">
                        <i class="pi pi-instagram text-xl"></i>
                    </a>
                </div>
            </div>
        </div>
    `
})
export class AppFooterComponent {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
}